import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import 'antd/dist/antd.css';
import styles from './styles.scss';
import schema from './common/schema';
import { RestBuilder } from './public/utils/rest';
import { isTruthy } from './public/utils/common';

import {
    tokenSelector,
    userIdSelector,
    authenticatedSelector,
} from './common/selectors/auth';

import {
    loginAction,
    logoutAction,
} from './common/action-creators/auth';
import {
    startSessionAction,
    stopSessionAction,
} from './common/middlewares/authManager';

import Multiplexer from './Multiplexer';

import {
    urlForTokenSync,
    paramsForGet,
} from './common/rest';

const mapStateToProps = state => ({
    user: userIdSelector(state),
    authenticated: authenticatedSelector(state),
    token: tokenSelector(state),
});

const mapDispatchToProps = dispatch => ({
    login: params => dispatch(loginAction(params)),
    logout: params => dispatch(logoutAction(params)),
    startSession: params => dispatch(startSessionAction(params)),
    stopSession: params => dispatch(stopSessionAction(params)),
});

const propTypes = {
    token: PropTypes.string,
    userId: PropTypes.number,
    login: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
    startSession: PropTypes.func.isRequired,
    stopSession: PropTypes.func.isRequired,
};

// const defaultProps = {
//     token: document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1') || '0',
//     userId: document.cookie.replace(/(?:(?:^|.*;\s*)id\s*=\s*([^;]*).*$)|^.*$/, '$1') || '0',
// };

const defaultProps = {
    token: '',
    userId: '',
};

@withRouter
@CSSModules(styles)
@connect(mapStateToProps, mapDispatchToProps)
export default class App extends React.Component {
    static propTypes = propTypes;
    static defaultProps = defaultProps;

    constructor(props) {
        super(props);

        this.loadingStyle = {
            alignItems: 'center',
            display: 'flex',
            height: '100vh',
            justifyContent: 'center',
            color: 'rgba(0, 0, 0, 0.5)',
            fontSize: '2em',
        };

        this.state = {
            pending: true,
            token: props.token,
        };
    }

    componentWillMount() {
    const {
            token,
            userId,
            authenticated,
        } = this.props;

        const hasPreviousSession = isTruthy(token) && isTruthy(userId);

        if (hasPreviousSession && authenticated) {
            this.requestForTokenSync = this.createRequestForTokenSync();
            this.requestForTokenSync.start();
        } else {
            console.warn('No previous session found or not authenticated');
            // Just pass, and go to login page
            this.setState({ pending: false });
        }
}

    componentWillUnmount() {
        if (this.requestForTokenSync) {
            this.requestForTokenSync.stop();
        }
    }

    // TODO: make this run for eternity
    createRequestForTokenSync = () => {
        const { token } = this.state;
        const url = urlForTokenSync;
        const tokenSyncRequest = new RestBuilder()
            .url(url)
            .params(paramsForGet({ token }))
            .decay(0.3)
            .maxRetryTime(2000)
            .success((response) => {
                console.log(response);
                try {
                    schema.validate(response, 'tokenSyncResponse');
                    const { userId, responseCode, message } = response;
                    // just change the userId and token (not actual login)
                    if (responseCode === 200) {
                        this.login({ userId, token: message });
                    } else {
                        console.warn('Unauthorized, invalid token, logging out');
                        this.logout();
                    }
                } catch (er) {
                    console.error(er);
                }
            })
            .failure((response) => {
                console.log(response);
                this.setState({ pending: false });
                this.logout();
            })
            .fatal((response) => {
                console.info('FATAL:', response);
                this.setState({ pending: false });
                this.logout();
            })
            .build();
        return tokenSyncRequest;
    }

    login = ({ userId, token: message }) => {
    this.props.login({ userId, token: message, authenticated: true });
    this.props.startSession(() => {
        // validate authentication
        const authState = { token: message, userId };
        localStorage.setItem('authState', JSON.stringify(authState));
        this.setState({ pending: false });
    });
}

    logout = () => {
    this.props.stopSession();
    this.props.logout();
    localStorage.removeItem('authState');
}

    render() {
        if (this.state.pending) {
            return (
                <div style={this.loadingStyle}>
                    Loading...
                </div>
            );
        }
        return (
            <Multiplexer />
        );
    }
}



// WEBPACK FOOTER //
// ./src/App.js